<template>
  <section class="grid-flex column">
    <section
      
      class="flex column w100"
    >
      <div class="box flex-1 w100">
        <div class="box-content">

          <div class="flex-1 w100">
            <p>
              Adicione todos seus pixels do Facebook Ads que serão retro alimentados com Informações dos seus Compradores + I.A. 
            </p>
            <p class="margin-top-s">
              Ou seja, vamos fazer o envio de mais informações para seu pixel ficar ainda mais inteligênte!
            </p>
          </div>

          <div class="flex-1 w100 margin-top-l">
            <div class="flex middle">
              <div class="flex-1">
                <tabs :data="populateTabs" v-model="currentTab"></tabs>
              </div>
            </div>
          </div>
          <div 
            v-if="currentTab === 'FBADS' || currentTab === 'GADS'"
            class="flex-1 w100 margin-top-s"
          >
            <div class="flex-1 w100">
              <div v-if="false" class="flex flex-1 middle between">
                <div class="button primary" @click="openModalCreate()">
                  {{ currentTab=='FBADS'? 'Criar Novo Pixel' : 'Criar nova Tag' }}
                </div>
                <div class="flex column">
                  Quantidade de Pixels: {{ account.used_limits.limit_pixels_retro | number }} / {{ account.plan_limits.limit_pixels_retro | number }}
                  <div class="margin-top-s">Precisa de mais Pixels? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
                </div>
              </div>
            </div>
            <ul>
              <li v-for="(pixel, index) in listPixels" :key="index">
                <div class="box margin-top-m item-box">
                  <div class="box-content">
                    <div class="flex middle row">
                      <div class="flex-3">
                        <div class="flex middle row">
                          <div class="flex-1 name margin-top-s flex middle">
                            <div class="switch-pixel">
                              <m-switch
                                  v-if="!loading"
                                  v-model="pixel.is_active_retro"
                                  @change="changeIsActive(pixel)"
                                ></m-switch>
                            </div>
                            <div>
                              <p>
                                {{ pixel.name }}
                              </p>
                              <small><b>{{ pixel.type_pixel }}</b></small>
                            </div>
                          </div>
                          <div class="flex-2 flex margin-top-s">
                            <div class="flex flex-1 details between">
                              <div class="flex column">
                                <div>{{ pixel.type_pixel === 'FBADS' ? 'Pixel ID' : 'TAG ID' }}</div>
                                <div><b>{{ pixel.pixel_id }}</b></div>
                              </div>
                            </div>
                            <div class="flex flex-1 details between">
                                <div class="flex column">
                                  <div>Taxa do valor da Conversão:</div>
                                  <div><b>{{ pixel.tax_value_conversion }}%</b></div>
                                </div>
                            </div>
                            <div class="flex flex-1 details between">
                                <div class="flex column">
                                  <div>Multiplicador de vendas:</div>
                                  <div><b>{{ pixel.tax_qtn_purchase }}x</b></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="action">
                        <div class="flex end">
                          <div class="button primary" @click="openToEdit(pixel)">EDITAR</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
        </div>
          <div v-if="isEmpty" class="margin-top-m">
            <div >
              <p>
                Não encontramos nenhum pixel criado. Crie seu primeiro pixel em "Tags / Pixels" para começar a rotina de retro alimentação.
              </p>
            </div>
          </div>

          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>

        </div>
      </div>
    </section>

    <section class="flex margin-top-l w100">
      <div class="box flex-1 w100">
        <div class="box-title">
          <div class="flex-1 w100">
              <div class="flex flex-1 middle between">
                Últimos eventos enviados
                <div class="flex column">
                  Total de eventos enviados nas últimas 72 horas: {{ totalLogs | number }}
                </div>
              </div>
            </div>
        </div>
        <div class="box-content max-table">
          <ul>
              <li v-for="(log, index) in logEvents" :key="index">
                <div class="box margin-top-m item-box">
                  <div class="box-content">
                    <div class="flex middle row">
                      <div class="flex-3">
                        <div class="flex middle row">
                          <div class="flex-1 name margin-top-s">
                            <p>
                              {{ log.type_event }}
                            </p>
                            <small><b>{{ log.platform }}</b></small>
                          </div>
                          <div class="flex-2 margin-top-s">
                            <div class="flex details between">
                              <div class="flex column">
                                <div>Pixel ID</div>
                                <div>{{ log.pixel_id }}</div>
                              </div>
                              <div class="flex column">
                                <div>Data</div>
                                <div>{{ log.created_at | date }}</div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-1 flex end">
                              <div class="button secondary" @click="openModalDetail(log)">Ver dados do Evento</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-if="isEmptyLog">
                Parece que não encontramos nenhum evento enviado nas últimas 24 horas...
              </li>
              <div v-if="loadingLogs">
                <content-loading>
                  <fake-line height="30"></fake-line>
                  <fake-line height="30"></fake-line>
                  <fake-line height="30"></fake-line>
                  <fake-line height="30"></fake-line>
                </content-loading>
              </div>
            </ul>
        </div>
      </div>
    </section>

    <!-- modal create / edit -->
    <modal
        :title="titleModal"
        :show="showModalCreateOrUpdate"
        @close="closeToEdit()"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form autocomplete="off" class="w100">
              <div class="flex-1 w100 margin-top-m">
                <div>
                  <label>Enviar apenas VENDAS APROVADAS (Pagas):</label>
                </div>
                <div class="switch-pixel">
                  <m-switch
                        v-model="newPixel.only_approved_sales"
                    ></m-switch>
                </div>

              </div>
              
              <div class="flex-1 w100 margin-top-m">
                <div>
                  <label>Taxa do valor da conversão:</label>
                </div>
                <input
                  class="input"
                  type="number"
                  v-model="newPixel.tax_value_conversion"
                  autocomplete="off"
                  max="10000"
                  min="1"
                />
                <small>Deixa ajustar o valor que vai ser passado no purchase para a META. Valor Padrão 100%.</small>
              </div>
              <div class="flex-1 w100 margin-top-m">
                <div>
                  <label>Multiplicador de vendas:</label>
                </div>
                <input
                  class="input"
                  type="number"
                  v-model="newPixel.tax_qtn_purchase"
                  max="50"
                  min="1"
                  autocomplete="off"
                />
                <small>Deixa ajustar se deseja que a mesma venda apareça mais de uma vez na META. Valor Padrão 1x.</small>
              </div>

              <div class="flex-1 w100 margin-top-m">
                <div>
                  <label>Nome do Produto</label>
                </div>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newPixel.product_name"
                  autocomplete="off"
                />
                <small>Limita os disparos apenas para vendas deste produto.</small>
              </div>

            </form>
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="saveOrUpdatePixel()">{{isEdit ? 'SALVAR': 'CRIAR'}}</div>
            </div>
          </div>
        </div>
      </modal>

          <!-- modal create / edit -->
    <modal
        title="Detalhes do evento"
        :show="showModalDetail"
        @close="showModalDetail = false"
        :largebox="true"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <div v-if="selectedLog">
              <JsonFormatter 
                :data="selectedLog.custom_fields"
                title="dados-do-evento.json"
                theme="github"
                :show-header="false"
                :show-line-numbers="false"
                :show-stats="false"
                :indent="4"
                max-height="300px"
                :collapsed="false"
                @formatted="onCustomFormatted"
                @error="onError"
              />
            </div>
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="showModalDetail = false">Fechar</div>
            </div>
          </div>
        </div>
      </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse pixel?"
      @cancel="
        showModalDelete = false;
        selectedPixel = null;
      "
      @accept="deletePixel(selectedPixel.id)"
    ></modal-confirm>

  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Tabs from "@/components/tabs/Tabs";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
import MSwitch from "@/components/MSwitch.vue";
import JsonFormatter from '@/components/JsonFormatter.vue'

import {
  getPixels,
  getLogEvents,
  createPixel,
  updatePixel,
  deletePixel,
} from "@/services/populatePixel";

const EMPTY_PIXEL = {
  name: "",
  is_active: true,
  is_active_retro: false,
  pixel_id: "",
  api_key: "",
  conversion_code: "",
  type_pixel: "",
  product_name: "",
  domains: "",
  tax_value_conversion: "",
  tax_qtn_purchase: "",
  only_approved_sales: ""
};

export default {
  name: "populate-pixel",
  components: {
    Tabs,
    Modal,
    ModalConfirm,
    MSwitch,
    JsonFormatter
  },
  data() {
    return {
      loading: false,
      loadingLogs: false,
      currentTab: "FBADS",
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedPixel: null,
      populateTabs: [
        {
          name: "FBADS",
          title: "Facebook Ads",
        },
        // {
        //   name: "GADS",
        //   title: "Google Ads",
        // },
      ],
      logEvents: [],
      newPixel: Object.assign({}, EMPTY_PIXEL),
      pixels: [],
      totalPixels: 0,
      totalLogs: 0,
      //
      selectedLog: null,
      showModalDetail: false,
    };
  },
  mounted() {
    this.getPixels()
    this.getLogEvents()
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    listPixels() {
      return this.pixels.filter(e => e.type_pixel	=== this.currentTab)
    },
    isEmpty() {
      return this.totalPixels === 0 && !this.loading;
    },
    isEmptyLog() {
      return this.totalLogs === 0 && !this.loadingLogs;
    },
    isEdit() {
      if (this.newPixel && this.newPixel.id) {
        return true
      }
      return false
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_pixels_retro <= this.account.used_limits.limit_pixels_retro) {
        return true
      }

      return false
    },
    titleModal() {
      if (this.currentTab == 'FBADS') {
        return this.isEdit ? 'EDITAR RETRO ALIMENTAÇÃO': 'CRIAR PIXEL'
      } else {
        return this.isEdit ? 'EDITAR TAG': 'CRIAR TAG'
      }
    }
  },
  methods: {
    openModalDetail(log) {
      this.selectedLog = log
      this.showModalDetail = true
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de Pixels do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    openToDelete(pixel) {
      this.showModalDelete = true
      this.selectedPixel = pixel
    },
    openToEdit(pixel) {
      this.showModalCreateOrUpdate = true
      this.newPixel = pixel
    },
    closeToEdit() {
      this.showModalCreateOrUpdate = false
      this.newPixel = Object.assign({}, EMPTY_PIXEL)
    },
    changeIsActive(pixel) {
      this.newPixel = pixel
      this.updatePixel(this.newPixel.id)
    },
    saveOrUpdatePixel() {
      if (this.isEdit) {
        this.updatePixel(this.newPixel.id)
      } else {
        this.createPixel()
      }
      this.closeToEdit()
    },
    getLogEvents() {
      this.loadingLogs = true
      getLogEvents()
        .then((result) => {
          this.logEvents = result.logs;
          this.totalLogs = result.total;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loadingLogs = false
        })
    },
    getPixels() {
      this.loading = true
      getPixels()
        .then((result) => {
          this.pixels = result.pixels;
          this.totalPixels = result.total;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false
        })
    },
    createPixel() {
      let params = {
        name: this.newPixel.name,
        pixel_id: this.newPixel.pixel_id,
        api_key: this.newPixel.api_key,
        conversion_code: this.newPixel.conversion_code,
        product_name: this.newPixel.product_name,
        domains: this.newPixel.domains,
        type_pixel: this.currentTab,
      };

      createPixel(params)
        .then((result) => {
          this.pixels.push(result);

          this.$toast.success({
            title: "Sucesso",
            message: "Pixel criado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updatePixel(pixelId) {
      let params = {
        name: this.newPixel.name,
        pixel_id: this.newPixel.pixel_id,
        is_active_retro: this.newPixel.is_active_retro,
        is_active: this.newPixel.is_active,
        api_key: this.newPixel.api_key,
        product_name: this.newPixel.product_name,
        domains: this.newPixel.domains,
        conversion_code: this.newPixel.conversion_code,
        type_pixel: this.currentTab,
        tax_value_conversion: this.newPixel.tax_value_conversion,
        tax_qtn_purchase: this.newPixel.tax_qtn_purchase,
        only_approved_sales: this.newPixel.only_approved_sales
      };

      updatePixel(pixelId, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Retro Alimentação editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deletePixel(pixelId) {
      deletePixel(pixelId)
        .then(() => {
          this.pixels = this.pixels.filter(p => p.id != pixelId)

          this.$toast.success({
            title: "Sucesso",
            message: "Pixel deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.showModalDelete = false;
          this.selectedPixel = null;
        }) ;
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.item-box {
  border-radius: 5px;
  border: 1px solid #eee;
}


.max-table {
  overflow-y: scroll;
  max-height: 400px;
  padding-bottom: 16px;
}

.switch-pixel {
  margin-right: 14px;
}

.code-json {
  max-width: 90%;
  display: inline-block;
}
</style>
